import React, {useState} from 'react';
import { CardBody, Collapse } from "reactstrap";
import { Link } from 'gatsby';
import { IFaqItem } from '../../Interfaces/shared';


const AccordionItem = ({ item }: { item: IFaqItem }) => {

  const [open, setOpen] = useState(false);

  return (
    <div className="mb-3">
      <Link
        to="#"
        className="accordion-list"
        onClick={event => { event.preventDefault(); setOpen(!open)}}
        style={{ cursor: "pointer", background: "rgba(85, 110, 230, 0.1)"}}
        >
        <div>{item.question}</div>
        <i className={open ? "mdi mdi-minus accor-plus-icon" : "mdi mdi-plus accor-plus-icon"}/>
      </Link>

      <Collapse isOpen={open}>
        <CardBody>
          <div className="mb-0" dangerouslySetInnerHTML={{ __html: item.answer }} />
        </CardBody>
      </Collapse>
    </div>
  )
}

export default AccordionItem;
